import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CheckBlock } from '../../../dmo/check-block';

@Component({
  selector: 'ls-check-block',
  templateUrl: './check-block.component.html',
  styleUrls: ['./check-block.component.scss']
})
export class CheckBlockComponent {
  @Input()
  public checkBlock: CheckBlock;
  @Output()
  public stateChange: EventEmitter<CheckBlock> = new EventEmitter<CheckBlock>();

  public toggle(): void {
    this.checkBlock.checked = !this.checkBlock.checked;
    this.stateChange.emit(this.checkBlock);
  }
}
